var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.6 53.9",
    style: {
      enableBackground: "new 0 0 63.6 53.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#14A800;}\r\n\t.st2{display:inline;fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st3{display:inline;}\r\n\t.st4{font-family:'DejaVuSansMono-Bold';}\r\n\t.st5{font-size:18px;}\r\n\t.st6{font-size:14px;}\r\n\t.st7{display:inline;fill:none;stroke:#231F20;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#231F20;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st9{display:inline;fill:#18A74A;stroke:#231F20;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st10{display:inline;fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st11{display:inline;fill:#18A74A;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st12{display:inline;fill:#18A74A;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st14{fill:#14A800;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31-4.9L43.2,5.8c0,0-6.7,2.4-10.6-0.3S31-4.9,31-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.4-5.8H2.2c0,0-5.6,0.2-5.7,6.5v44.6c0,0-0.6,6.5,5.6,6.9h34.6c0,0,7-0.9,6.6-8.6v-37c0,0-4.9,0.5-6.7,0.5 c-2.1,0.1-6.4-1.3-6.7-6.1C29.7-1.4,30.4-5.8,30.4-5.8z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4.2601 23.4397)",
    className: "st3 st4 st5"
  }, "{:}"), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -3.6,
    y1: 36.3,
    x2: 42.7,
    y2: 36.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.8809 48.1637)",
    className: "st3 st4 st6"
  }, "css"), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30.8,
    y1: -6,
    x2: 43.5,
    y2: 6.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M6.9,5.2h59.5v-9.6c0,0,0-5.1-4.7-5.5L12-9.8c0,0-5-0.8-5,5.1L6.9,5.2L6.9,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M6.9,5.2l-0.1,50c0,0,0,5.6,4.7,5.3H61c0,0,5.4-0.2,5.4-8.6V5.2C66.4,5.2,6.9,5.2,6.9,5.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 13,
    y1: 48.5,
    x2: 60.4,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 13.5,
    y1: 53.8,
    x2: 37.8,
    y2: 53.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 39.2,
    y1: -2.3,
    x2: 60.7,
    y2: -2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.5,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M37.9,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.9,23.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 12.9,
    y1: 26.4,
    x2: 26.1,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 12.9,
    y1: 23.4,
    x2: 19.9,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 11.5,
    className: "st8",
    width: 12.4,
    height: 8.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 29.9,
    y1: 26.4,
    x2: 43.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 29.9,
    y1: 23.4,
    x2: 36.9,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 11.5,
    className: "st8",
    width: 12.4,
    height: 8.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 46.8,
    y1: 26.4,
    x2: 60.1,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 46.8,
    y1: 23.4,
    x2: 53.8,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 11.5,
    className: "st8",
    width: 12.4,
    height: 8.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 31.8,
    className: "st9",
    width: 46.4,
    height: 11.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 15.3,
    cy: -2.1,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 22.1,
    cy: -2.1,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 28.6,
    cy: -2.1,
    r: 1.8
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.3,39.8H10.1c-1.9,0-3.4-1.5-3.4-3.4v-39C6.7-4.5,8.2-6,10.1-6h55.2c1.9,0,3.4,1.5,3.4,3.4v38.9 C68.8,38.2,67.2,39.8,65.3,39.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "6.7,23.2 16.1,14.2 18.6,11.7 20.9,14.2 31.5,24.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "17.4,39.8 51.1,4.4 68.8,20.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 32.4,
    cy: 6.9,
    r: 5.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "19.5,33.8 17,47.2 12.6,47.2 12.6,53.6 31.5,53.6 31.5,47.6 27.2,47.6 29.1,37.9 38.8,37.9 41,47.5  36.9,47.5 36.9,53.6 55.9,53.6 55.9,47.4 52.4,47.4 42.6,0.7 26.3,0.7 20.1,31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "37,22.9 34.3,12.3 30,30.5 39,30.5 37.7,25.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 9.3,
    y1: 0.7,
    x2: 52.6,
    y2: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 6.1,
    y1: 3.4,
    x2: 6.1,
    y2: 39.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 8.7,
    y1: 42.9,
    x2: 17.8,
    y2: 42.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 28.1,
    y1: 43,
    x2: 39.9,
    y2: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 51.5,
    y1: 43.3,
    x2: 60.1,
    y2: 43.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 63,
    y1: 39.5,
    x2: 63,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 60.3,
    y1: 0.7,
    x2: 55.5,
    y2: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: -1.9,
    className: "st10",
    width: 5.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 39.5,
    className: "st10",
    width: 5.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1,
    y: -1.9,
    className: "st10",
    width: 5.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1,
    y: 39.5,
    className: "st10",
    width: 5.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "26.3,0.7 27.9,-6 41.2,-6 42.6,0.7  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.7,15.3h6.9L30.4,31l-5,0.1c0,0-1.1,0-1.1,1.9c0,1.2,0.9,1.5,1.9,1.5h22.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32.1,
    cy: 37.1,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 41.9,
    cy: 37.1,
    r: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 13.8,
    y1: 19.8,
    x2: 22.9,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 16.9,
    y1: 23.8,
    x2: 24.9,
    y2: 23.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19.7,
    y1: 27.5,
    x2: 26.8,
    y2: 27.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "27.5,19 48.4,19 44.5,31 30.4,31  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 40.8,
    y1: 1.9,
    x2: 56.9,
    y2: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.7,
    cy: 1.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 18.3,
    cy: 1.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 24.2,
    cy: 1.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.4,48.8H10.9c-2.4,0-4.4-2-4.4-4.4v-43C6.5-1,8.5-3,10.9-3h45.6c2.4,0,4.4,2,4.4,4.4v43 C60.9,46.8,58.9,48.8,56.4,48.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 5.6,
    y1: 6.3,
    x2: 60.9,
    y2: 6.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35__1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M57.7,9.2H8.9C8.2,9.2,7.7,8.7,7.7,8v-9.4c0-0.7,0.6-1.2,1.2-1.2h48.8c0.7,0,1.2,0.6,1.2,1.2V8 C58.9,8.7,58.4,9.2,57.7,9.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LINES_3_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 6.8,
    y1: 15,
    x2: 30.7,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 6.8,
    y1: 22,
    x2: 30.7,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 6.8,
    y1: 28,
    x2: 30.7,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 6.8,
    y1: 35,
    x2: 30.7,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 6.8,
    y1: 41,
    x2: 30.7,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 6.8,
    y1: 48,
    x2: 30.7,
    y2: 48
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINES_2_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.9,
    y1: 15,
    x2: 59.8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.9,
    y1: 22,
    x2: 59.8,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.9,
    y1: 28,
    x2: 59.8,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.9,
    y1: 35,
    x2: 59.8,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.9,
    y1: 41,
    x2: 59.8,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 35.9,
    y1: 48,
    x2: 59.8,
    y2: 48
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M59.4,44.4H4.2c-1.9,0-3.4-1.5-3.4-3.4V4.2c0-1.9,1.5-3.4,3.4-3.4h55.2c1.9,0,3.4,1.5,3.4,3.4v36.7 C62.8,42.8,61.3,44.4,59.4,44.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 26.5,
    cy: 14.6,
    rx: 4.8,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 21.7,
    cy: 51.1,
    rx: 2.2,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 31.7,
    cy: 51.1,
    rx: 2.2,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 41.7,
    cy: 51.1,
    rx: 2.2,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "53.8,20.3 56.7,22.7 54,25.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "53.8,20.3 56.7,22.7 54,25.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "9.2,20.3 6.3,22.7 9,25.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "35.7,19.1 49.3,35.6 22.1,36.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "27.1,29.8 24,24.9 15.4,36.2 25.1,36  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.cdf3f25478e0fc953d63d3b8e6b0f546.svg";
export { ForwardRef as ReactComponent };